export default {
  title: 'Variantă nouă',
  fields: {
    product: {
      label: 'Produs',
    },
    name: {
      label: 'Nume',
      placeholder: 'Mare',
    },
    price: {
      label: 'Preț suplimentar',
    },
  },
  buttons: {
    save: 'Salvați',
    close: 'Închideți',
  },
  toasts: {
    variant_got_created: 'Varianta a fost creată',
    variant_got_updated: 'Varianta a fost actualizată',
  },
};
